import { RegularExpressions } from "../../../../../assets/regularExpressionAssets";
import { enumSocialMediaPostType } from "../../../../enums";
import { ISocialMediaPostDisplaySpecs } from "../ISocialMediaPostDisplaySpecs";

/**
 * @function deriveDisplaySpecsForTikTok Derives the specs needed to display a TikTok Social Media Post from a raw reference
 * @param socialMediaPostRawReference The raw reference associated with the Social Media Post (eg, could be a URL or could be an <iframe>)
 */
export function deriveDisplaySpecsForTikTok(socialMediaPostRawReference: string): ISocialMediaPostDisplaySpecs {

  // set default displaySpecs values for TikTok
  let displaySpecs: ISocialMediaPostDisplaySpecs = { socialMediaPostType: enumSocialMediaPostType.Undefined, url: '', width: '100%', height: '100%' };;

  // execute the regular expression against the url to determine if the socialMediaPostRawReference represents a standard TikTok Post EmbedUrl
  const matchEmbedUrl: RegExpExecArray | null = RegularExpressions.TikTokPostEmbedUrl.exec(socialMediaPostRawReference);

  // if a match was made for a simple embed url...
  if (matchEmbedUrl && matchEmbedUrl.groups && matchEmbedUrl.groups.embedUrl) {
    // set the specs for displaying the post
    displaySpecs = { socialMediaPostType: enumSocialMediaPostType.TikTok, url: matchEmbedUrl.groups.embedUrl, width: '100%', height: '100%' };
  } 

  return displaySpecs;
}
